import { api } from "@/frontend/services/api";
import type {
  CreateMatchScoreRequestDTO,
  UpdateMatchScoreRequestDTO,
  MatchScoreResponseDTO,
  MatchScoresPaginatedResponseDTO,
  MatchScoreQueryDTO,
  ApiResponse,
} from "@/shared/dto";

const BASE_URL = "/match-scores/private";

export const matchScoreService = {
  getPaginate: (params?: MatchScoreQueryDTO) =>
    api.getWithParams<ApiResponse<MatchScoresPaginatedResponseDTO>>(BASE_URL, params),
  getById: (id: string) =>
    api.get<ApiResponse<MatchScoreResponseDTO>>(`${BASE_URL}/${id}`),
  getByEvent: (tournamentFormatId: string) =>
    api.get<ApiResponse<MatchScoreResponseDTO[]>>(`${BASE_URL}/by-event/${tournamentFormatId}`),
  create: (data: CreateMatchScoreRequestDTO) =>
    api.post<ApiResponse<MatchScoreResponseDTO>>(BASE_URL, data),
  update: (id: string, data: UpdateMatchScoreRequestDTO) =>
    api.put<ApiResponse<MatchScoreResponseDTO>>(`${BASE_URL}/${id}`, data),
  delete: (id: string) =>
    api.delete<ApiResponse<void>>(`${BASE_URL}/${id}`),
};
